import { Component, Prop, State, h, Listen } from '@stencil/core';
import { ConversationalSearchFollowUpActions } from '../follow-up-actions/follow-up-actions';
import type { ConversationalSearchFollowups, ConversationalSearchProductHierarchy, ConversationalSearchProductSuggestions, ConversationalSearchRefinements } from '../../../../conversational-search-types/conversational-search-types.type';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';
import { buildObsoleteProductsObject } from '../../../../conversational-search-logic/utils/utils';
import { extractProductHierarchySubLevels, getCharacteristicsFollowup } from './follow-up-mediator-helpers';

@Component({
  tag: 'uiaas-conversational-search-message-follow-up-mediator',
  styleUrl: 'follow-up-mediator.scss',
  shadow: true,
})
export class ConversationalSearchFollowUpMediator {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly conversationalSearchBrandUrl: string;
  @Prop() readonly query: string;
  @Prop() readonly country: string;
  @Prop() readonly language: string;
  @Prop() readonly hierarchy: ConversationalSearchProductHierarchy;
  @Prop() readonly suggestions: ConversationalSearchProductSuggestions[];
  @Prop() readonly followups: ConversationalSearchFollowups['followups'];

  @State() isRefineTriggered = false;
  @State() isFeedbackTriggered = false;
  @State() queryChanged = false;

  private feedbackCallback = () => {
      this.isFeedbackTriggered = true;
  };

  private refineCallback = () => {
      this.isRefineTriggered = true;
  };

  @Listen('conversational-search:messages-update', { target: 'window' })
  handleMessagesChange() {
      this.queryChanged = true;
  }

  private getRefinementData = (): ConversationalSearchRefinements => {
      const followUpCharacteristics = getCharacteristicsFollowup(this.followups);
      const subLevels = this.hierarchy?.subLevels;
      const productHierarchyNestedSubLevels = extractProductHierarchySubLevels(subLevels);
      const result = followUpCharacteristics?.length ? followUpCharacteristics : productHierarchyNestedSubLevels;

      return result;
  };

  private selectCorrectFollowUp() {
      const refinementData = this.getRefinementData();
      const productssubstitutionIds = buildObsoleteProductsObject(this.suggestions)?.productIds;

      if (!this.isRefineTriggered && !this.isFeedbackTriggered) {
        return (
          <section class={{'conversational-search-message-follow-up-mediator__actions': this.queryChanged}}>
            <ConversationalSearchFollowUpActions
              labelProvider={this.labelProvider}
              query={this.query}
              refineCallback={() => this.refineCallback()}
              feedbackCallback={() => this.feedbackCallback()}
              country={this.country}
              language={this.language}
              substitutionProductsIds={productssubstitutionIds}
              refinementData={refinementData}
              conversationalSearchBrandUrl={this.conversationalSearchBrandUrl}
            />
          </section>
        );
      }

      if (this.isRefineTriggered && !this.isFeedbackTriggered) {
        return (
          <uiaas-search-conversational-search-messages-wrapper isOverflowing={true}>
            <uiaas-conversational-search-message-follow-up-refine
              labelProvider={this.labelProvider}
              query={this.query}
              refinementData={refinementData}
              queryChanged={this.queryChanged}
            />
          </uiaas-search-conversational-search-messages-wrapper>
        );
      }

      if (!this.isRefineTriggered && this.isFeedbackTriggered) {
        return (
          <uiaas-search-conversational-search-messages-wrapper>
            <uiaas-conversational-search-message-follow-up-feedback
              labelProvider={this.labelProvider}
              query={this.query}
              queryChanged={this.queryChanged}
            />
          </uiaas-search-conversational-search-messages-wrapper>
        );
      }
  }

  render() {
      const isInvoked = this.isFeedbackTriggered || this.isRefineTriggered;

      return (
        <section class={{'conversational-search-message-follow-up-mediator': isInvoked}}>
          {this.selectCorrectFollowUp()}
        </section>
      );
  }
}
